import { FC } from 'react';
import { Globe } from 'lucide-react';
import { getUserTimezone, getTimezoneOffset } from '../../lib/helpers';

export const TimezoneDisplay: FC = () => {
  const userTimezone = getUserTimezone();
  const timezoneOffset = getTimezoneOffset();

  return (
    <div className="hidden lg:flex flex-col gap-2">
      <p className="text-(--neutral-black-NB1000) [font-size:var(--fs-l3)]! font-semibold m-0!">
        Time zone
      </p>
      <div className="flex items-center gap-2">
        <Globe className="w-5 h-5 text-(--neutral-black-NB800)" />
        <span className="text-(--neutral-black-NB800)! [font-size:var(--fs-l3)]!">
          {userTimezone} ({timezoneOffset})
        </span>
      </div>
    </div>
  );
};
